import { render, staticRenderFns } from "./TilledCardIndex.vue?vue&type=template&id=d8a834de&scoped=true"
import script from "./TilledCardIndex.vue?vue&type=script&lang=js"
export * from "./TilledCardIndex.vue?vue&type=script&lang=js"
import style0 from "./TilledCardIndex.vue?vue&type=style&index=0&id=d8a834de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a834de",
  null
  
)

export default component.exports